import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { t } from 'ttag'
import { CHALLENGE_ADMIN_STEP_DETAILS, FormData } from '../../ChallengeAdmin'

import YumField from '../../../../components/YumInput/YumInput'
import ErrorMessage from '../../../../components/ErrorMessage/ErrorMessage'

import { ReactComponent as TitleActiveIcon } from '../../../../assets/v3/icons/title-active.svg'
import { ReactComponent as TitleInactiveIcon } from '../../../../assets/v3/icons/title-inactive.svg'
import { ReactComponent as PrizeActiveIcon } from '../../../../assets/v3/icons/prize-active.svg'
import { ReactComponent as PrizeInactiveIcon } from '../../../../assets/v3/icons/prize-inactive.svg'
import { ReactComponent as DescriptionActiveIcon } from '../../../../assets/v3/icons/description-active.svg'
import { ReactComponent as DescriptionInactiveIcon } from '../../../../assets/v3/icons/description-inactive.svg'

interface ChallengeStepPeriodProps {
  control: Control<FormData>
  errors: FieldErrors<FormData>
  formStep: number
}

export default function ChallengeStepDetails(props: ChallengeStepPeriodProps) {
  const { control, errors, formStep } = props

  const challengeNameField = (
    <Controller
      name="title"
      rules={{ required: formStep === CHALLENGE_ADMIN_STEP_DETAILS }}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Challenge name (required)`}
          error={!!errors.title}
          startIcon={TitleInactiveIcon}
          /*startIcon={TitleActiveIcon}
          startIconInactive={TitleInactiveIcon}*/
          {...otherField}
          // Hand the RHF ref to the input so shouldFocusError can focus it.
          inputRef={ref}
          value={otherField.value ?? ''}
          style={errors.title ? { marginBottom: 0 } : undefined}
          inputProps={{
            autoComplete: 'off',
            'aria-required': 'true',
            'aria-invalid': errors.title ? 'true' : 'false',
            'aria-describedby': errors.title ? 'challenge-title-error' : undefined,
          }}
        />
      )}
    />
  )

  const prizeField = (
    <Controller
      name="prize"
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Prize`}
          error={!!errors.prize}
          startIcon={PrizeInactiveIcon}
          /*startIcon={PrizeActiveIcon}
          startIconInactive={PrizeInactiveIcon}*/
          multiline
          minRows={2}
          {...otherField}
          inputRef={ref}
          value={otherField.value ?? ''}
        />
      )}
    />
  )

  const descriptionField = (
    <Controller
      name="description"
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Description`}
          error={!!errors.description}
          startIcon={DescriptionInactiveIcon}
          /*startIcon={DescriptionActiveIcon}
          startIconInactive={DescriptionInactiveIcon}*/
          multiline
          minRows={2}
          {...otherField}
          inputRef={ref}
          value={otherField.value ?? ''}
        />
      )}
    />
  )

  return (
    <>
      {challengeNameField}
      {errors.title && (
        <div style={{ marginBottom: '16px' }}>
          <ErrorMessage id="challenge-title-error">{t`Please enter a challenge name.`}</ErrorMessage>
        </div>
      )}
      {prizeField}
      {descriptionField}
    </>
  )
}
